module.exports = __webpack_public_path__ + "static/media/loginOtp.8a39d26d.svg";